import { render, staticRenderFns } from "./NbaPositionOpti.vue?vue&type=template&id=64a6cd11&scoped=true"
import script from "./NbaPositionOpti.vue?vue&type=script&lang=js"
export * from "./NbaPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./NbaPositionOpti.vue?vue&type=style&index=0&id=64a6cd11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6cd11",
  null
  
)

export default component.exports